export enum OptionIndexEnum {
    UP = 0,
    DOWN = 1,
    LAST = 2,
    FIRST = 3
};